import React from 'react';

/**
 * Icône "cercle" pour l'entrée de forme "Cercle" du menu — `@ant-design/icons` n'a aucune icône de
 * cercle "neutre" (toutes les icônes `*CircleOutlined` du package combinent l'anneau avec un symbole
 * sémantique interne — horloge, point d'interrogation, etc. — inadapté ici). Reprend tel quel le
 * tracé de l'anneau extérieur partagé par toute la famille `*CircleOutlined` (ex.
 * `ClockCircleOutlined`, voir `@ant-design/icons-svg`), sans le symbole interne, pour rester visuellement
 * cohérent avec les icônes `Outlined` du reste du menu (même épaisseur de trait, même `viewBox`).
 */
export default function CircleOutlined({ style }: { style?: React.CSSProperties; }) {
	return (
		<span role="img" aria-label="cercle" className="anticon" style={style}>
			<svg viewBox="64 64 896 896" focusable="false" width="1em" height="1em" fill="currentColor" aria-hidden="true">
				<path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z" />
			</svg>
		</span>
	);
}
